import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FilterReusableComp from "../../../components/FilterReusableComp";
import CurrencyText from "../../../components/fragment/cur-text/CurrencyText";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import {
  getDeletedCustomers,
  getDeletedCustomersExport,
  restoreCustomer,
} from "../../../redux/customer";
import { getAllCountries } from "../../../redux/settings";
import RootState from "../../../redux/type";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import "../../../styles/dashboard/customer/CustomersIndex.css";
import { formatTime } from "../../../utils/Helper";
import { systemRoles } from "../../../utils/roles";
import ActionContext from "../../../context/ActionContext";
import RazorTable from "../../../components/razor-reuse/tables/RazorTable";
import RazorTableRow from "../../../components/razor-reuse/tables/RazorTableRow";
import TextColorFragment from "../../../components/fragment/text-color/TextColorFragment";
import DotActionDropFragment from "../../../components/fragment/actionIconFragment/DotActionDropFragment";

const DeleteCustomerIndex = () => {
  const actionCtx = useContext(ActionContext);
  const navigate = useNavigate();
  const { loading_deleted_customers, deleted_customers, loading_modal } =
    useSelector((state: RootState) => state.customer);
  const { user } = useSelector((state: RootState) => state.auth);
  const { all_countries_drop } = useSelector(
    (state: RootState) => state.settings,
  );
  const [currentPageVal, setCurrentPage] = useState(1);
  const [restoreTarget, setRestoreTarget] = useState<any>(null);
  const [reasonTarget, setReasonTarget] = useState<any>(null);
  const [search, setSearch] = useState<string>("");
  const [nationalityVal, setNationalityVal] = useState<any>("");
  const dispatch = useDispatch();

  const formatOptionLabelTwo = ({ label, imageUrl }: any) => (
    <CurrencyText url={imageUrl} text={label} imgSize="20px" />
  );

  const nationalityOptions = [
    { value: "", label: "All" },
    ...(all_countries_drop || []),
  ];

  const headerList = [
    "Full Name",
    "Email Address",
    "Verif. Status",
    "Phone No.",
    "Account Status",
    "Date Deleted",
    "Country of Res.",
    "Last Activity",
  ];
  // useEffect to check if user has permission to view transactions
  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[3]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, [user?.permissions]);

  useEffect(() => {
    if (all_countries_drop?.length < 1) dispatch(getAllCountries({}) as any);
  }, [all_countries_drop?.length]);

  const obj = {
    page: currentPageVal,
    per_page: actionCtx?.perPage?.label,
    search,
    nationality: nationalityVal?.value || "",
  };

  useEffect(() => {
    if (user?.permissions?.includes(systemRoles[3])) {
      dispatch(getDeletedCustomers(obj) as any);
    }
  }, [
    currentPageVal,
    user?.permissions,
    actionCtx?.perPage,
    search,
    nationalityVal,
  ]);

  const handleRestore = async () => {
    if (!restoreTarget?.id) return;
    const result: any = await dispatch(
      restoreCustomer(restoreTarget.id) as any,
    );
    if (result?.payload?.data?.status) {
      setRestoreTarget(null);
      dispatch(getDeletedCustomers(obj) as any);
    }
  };

  const actionList = [
    {
      // icon: ALL_ICONS?.view,
      label: "View Details",
      onClick: (param?: any) => {
        if (user?.permissions?.includes(systemRoles[3])) {
          localStorage?.setItem("cors_key", param?.id);
          navigate(ALL_ROUTES?.DASHBOARD_CUSTOMER_SINGLE);
        }
      },
      textColor: "",
    },
    {
      // icon: ALL_ICONS?.view,
      label: "Reactivate User",
      onClick: (param?: any) => setRestoreTarget(param),
      textColor: "",
      hide: !user?.permissions?.includes("restore_user"),
    },
    {
      // icon: ALL_ICONS?.view,
      label: "View Deletion Reason",
      onClick: (param?: any) => setReasonTarget(param),
      textColor: "",
    },
  ];

  return (
    <>
      <DashboardLayoutMain
        loading={
          Object?.keys(deleted_customers)?.length < 1 &&
          loading_deleted_customers
        }
        title="Deleted Users"
      >
        <div className="customers-index-wrapper-smart-send">
          {/* filter section start */}
          <FilterReusableComp
            searchPlaceholder="Search by name or email"
            onSearch={(param: any) => {
              if (String(param)?.length > 2) {
                setSearch(param);
                setCurrentPage(1);
              }
              if (String(param)?.length < 1) {
                setSearch("");
                setCurrentPage(1);
              }
            }}
            defaultSelectTwo="Nationality"
            selectTwoList={nationalityOptions}
            selectTwoValue={nationalityVal}
            formatOptionLabelTwo={formatOptionLabelTwo}
            onSelectTwo={(param) => {
              setNationalityVal(param);
              setCurrentPage(1);
            }}
            onExport={() => {
              dispatch(
                getDeletedCustomersExport({
                  search,
                  nationality: nationalityVal?.value || "",
                  export: "csv",
                }) as any,
              );
            }}
          />
          {/* filter section end */}
          {/* table section start */}
          <div
            onClick={() => {
             
            }}
            className="table-section-box"
          >
            <RazorTable tableStrip={true} headerList={headerList}>
              {deleted_customers?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    loading={loading_deleted_customers}
                    key={idx}
                    one={`${chi?.first_name || "----"} ${chi?.last_name || "----"} `}
                    two={chi?.email || "----"}
                    three={
                      <TextColorFragment
                        text={
                          chi?.verification_status?.replace(/-/g, " ") || "----"
                        }
                      />
                    }
                    four={chi?.telephone || "----"}
                    five={
                      <TextColorFragment
                        color={
                          chi?.account_status === "active"
                            ? "rgba(0, 153, 51, 1)"
                            : chi?.account_status === "inactive"
                              ? "rgba(255, 192, 67, 1)"
                              : chi?.account_status === "Suspended"
                                ? "rgba(200, 16, 46, 1)"
                                : ""
                        }
                        text={chi?.account_status || "---"}
                      />
                    }
                    six={formatTime(chi?.deleted_at) || "----"}
                    seven={
                      <CurrencyText
                        // currency={chi?.location?.name || "ngn"}
                        text={chi?.location?.name}
                        url={chi?.location?.flag_url}
                        imgSize="2rem"
                        // className="currency-text-country"
                      />
                    }
                    eight={
                      <DotActionDropFragment list={actionList} detail={chi} />
                    }
                  />
                );
              })}
            </RazorTable>
          </div>

          {/* table section end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={deleted_customers?.meta?.current_page || 1}
            perPage={deleted_customers?.meta?.per_page}
            totalPage={deleted_customers?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
            }}
            hidePagination={loading_deleted_customers}
            showPerPage
          />
          {/* pagination  end */}
        </div>
      </DashboardLayoutMain>
      {/* Restore deleted customer account modal */}
      <ReuseModal
        visible={!!restoreTarget}
        loading={loading_modal}
        onClose={() => setRestoreTarget(null)}
        title="Restore Customer Account"
        btnLabel="Restore Account"
        btnColor="green-light"
        onBtnClick={handleRestore}
      >
        <p className="text-[14px] text-gray-01 -mb-[20px]">
          Are you sure you want to restore{" "}
          {restoreTarget?.first_name
            ? `${restoreTarget?.first_name} ${restoreTarget?.last_name || ""}'s`
            : "this"}{" "}
          account? This will reactivate the account and restore their access.
        </p>
      </ReuseModal>

      {/* View deletion reason modal */}
      <ReuseModal
        visible={!!reasonTarget}
        onClose={() => setReasonTarget(null)}
        title="Reason for Deletion"
        hideBtn
      >
        <p className="text-[14px] text-gray-01">
          {reasonTarget?.reason_for_deletion || "No reason provided"}
        </p>
      </ReuseModal>
    </>
  );
};

export default DeleteCustomerIndex;
